export default [
  {path: '/daysurgery', component: () => import('./views')},
  {path: '/daysurgery/rjhl', component: () => import('./views/rjhl')},
  {path: '/daysurgery/shoushu', component: () => import('./views/shoushu')},
  {
    path: '/daysurgery/home',
    name: 'dsHome',
    component: () => import('./views/home')
  },
  {path: '/daysurgery/all', component: () => import('./views/all')},
  {path: '/daysurgery/message', component: () => import('./views/message')},
  {path: '/daysurgery/team', component: () => import('./views/team')},
  {path: '/daysurgery/picc', component: () => import('./views/picc')},
  {
    path: '/daysurgery/news',
    meta: {
      keepAlive: true
    },
    component: () => import('./views/news')
  },
  {path: '/daysurgery/news/detail', component: () => import('./views/news/detail')},
  {path: '/daysurgery/news/search', component: () => import('./views/news/search')}
]



// WEBPACK FOOTER //
// ./src/page/daysurgery/daysurgery.js